// ScrollHandler.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollHandler() {
  const { pathname } = useLocation();
  const isFirstLoad = useRef(true);

  // 🟢 حفظ مكان الـ scroll قبل الإغلاق أو reload
  useEffect(() => {
    const saveScroll = () => {
      sessionStorage.setItem("scrollPosition", window.scrollY);
    };
    window.addEventListener("beforeunload", saveScroll);
    return () => {
      window.removeEventListener("beforeunload", saveScroll);
    };
  }, []);

  // 🟢 عند تغيير الـ route → scroll لأعلى (ماعدا أول load)
  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  // 🟢 بعد تحميل الصفحة بالكامل → استرجاع مكان الـ scroll
  useEffect(() => {
    const savedPosition = sessionStorage.getItem("scrollPosition");
    if (savedPosition) {
      // نستخدم setTimeout بسيط علشان نتأكد إن الـ DOM & data اتعملوا render
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedPosition, 10));
      }, 100);
    }
  }, []);

  return null;
}
